import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["message"],
  _excluded2 = ["message", "reply"];
import React from 'react';
import { MessageStatus, MessageType } from "../../../../shared/api";
import { useAppSelector } from "../../../../shared/model";
import { CellsView, FileView, ImageView, LocationView, TextView } from "../../../../entities/message/ui";
import { withMessageWrapper } from "../../../../entities/message/lib";
import { Captcha, ReloadButton } from "../../../../entities/captcha/ui";
import { selectRecreateProcess } from "../../../../entities/captcha/model";
var WrappedCaptcha = withMessageWrapper({
  withDate: false
})(Captcha);
var reloadButton = function reloadButton(message) {
  return /*#__PURE__*/React.createElement(ReloadButton, {
    message: message
  });
};
var CaptchaView = function CaptchaView(_ref) {
  var message = _ref.message,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var processedCaptchas = useAppSelector(selectRecreateProcess);
  var isProcessed = processedCaptchas.includes(message.messageId);
  return /*#__PURE__*/React.createElement(WrappedCaptcha, _extends({
    additionalControls: reloadButton(message),
    isLoading: isProcessed,
    message: message,
    offset: isProcessed || !message.captcha ? 'small' : 'none'
  }, otherProps));
};
export var MessageContent = function MessageContent(props) {
  var message = props.message,
    reply = props.reply,
    otherProps = _objectWithoutProperties(props, _excluded2);
  var type = message.message.type;
  if (type === MessageType.File) {
    return /*#__PURE__*/React.createElement(CellsView, _extends({
      message: message,
      reply: reply
    }, otherProps));
  }
  if (type === MessageType.Geolocation) {
    // TODO: Поправить на реальные координаты
    return /*#__PURE__*/React.createElement(LocationView, _extends({
      lat: 0,
      lng: 0,
      message: message,
      reply: reply
    }, otherProps));
  }
  if (type === MessageType.CAPTCHA) {
    return /*#__PURE__*/React.createElement(CaptchaView, _extends({
      message: message
    }, otherProps));
  }
  if (type === MessageType.Img) {
    return /*#__PURE__*/React.createElement(ImageView, _extends({
      message: message,
      withDate: message.messageStatus !== MessageStatus.sent
    }, otherProps));
  }
  if (type === MessageType.FileDoc) {
    return /*#__PURE__*/React.createElement(FileView, _extends({
      message: message
    }, otherProps));
  }
  return /*#__PURE__*/React.createElement(TextView, _extends({
    message: message,
    reply: reply
  }, otherProps));
};